var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletedraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.928 14A.915.915 0 0 1 2 13.097c0-.264.097-.472.277-.653L6.711 8 2.277 3.556A.905.905 0 0 1 2 2.916c0-.513.416-.902.928-.902a.87.87 0 0 1 .638.278l4.42 4.43 4.448-4.43A.837.837 0 0 1 13.086 2c.512 0 .914.403.914.903 0 .25-.083.458-.277.653L9.289 8l4.42 4.43c.18.181.277.403.277.667 0 .5-.402.903-.914.903a.966.966 0 0 1-.665-.278l-4.42-4.43-4.393 4.43a.932.932 0 0 1-.666.278z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedraft);
export default __webpack_public_path__ + "static/media/deletedraft.8ae9bddb0b58878a46e5e7c12fa945a5.svg";
export { ForwardRef as ReactComponent };